




import Vue from 'vue';
import { EventBus } from '@/event-bus';
import markdown from 'markdown-it/dist/markdown-it.min.js';

const md = markdown({
  breaks: true,
});

export default Vue.extend({
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const filteredText = this.$options.filters.varReplace(this.text),
        parsedMarkupContainer = document.createElement('div'),
        markup = md.render(filteredText);

    parsedMarkupContainer.innerHTML = markup;

    (this.$refs.rendered as Element).replaceWith(this.convertLinks(parsedMarkupContainer));
  },
  methods: {
    convertLinks(parsedMarkupContainer: HTMLDivElement): HTMLDivElement {
      Array.from(parsedMarkupContainer.querySelectorAll('a')).forEach((ele) => {

        const href = ele.getAttribute('href');

        if (href.indexOf('route') >= 0) {
          const parsedHref = href.replace('route=%22', '').replace('%22', '');

          ele.onclick = () => {
            EventBus.$emit('routeClick', parsedHref);
          };
          ele.removeAttribute('href');
        } else if (href.indexOf('link:self') >= 0) {
          const parsedHref = href.replace('link:self=%22', '').replace('%22', '');

          ele.setAttribute('data-leaving-warning', 'true');
          ele.setAttribute('href', parsedHref);
        } else if (href.indexOf('action=') >= 0) {
          const parsedEvent = href.replace('action=%22', '').replace('%22', '');
          ele.onclick = () => {
            EventBus.$emit(parsedEvent);
          };
          ele.removeAttribute('href');
        } else {
          const parsedHref = href.replace('link=%22', '').replace('%22', '');

          ele.setAttribute('target', '_blank');
          ele.setAttribute('href', parsedHref);
        }
      });

      return parsedMarkupContainer;
    },
  },
});
